<template>

  <div>

    <div v-if="!finished" class="-ml-4 -mr-4 lg:-ml-8 lg:-mr-8 p-4 pt-8 mt-4 lg:mt-6 bg-grey-darkest">
      <div class="pb-8">
        <h1 class="text-center uppercase text-white mb-1 border-none">Als Anbieter anmelden</h1>
        <p class="text-white text-center">Du möchtest als Anbieter bei uns teilnehmen?<br />Schnell das Formular ausfüllen und du kannst direkt mit der Einrichtung starten!</p>
      </div>
    </div>

    <div v-if="finished" class="-ml-4 -mr-4 lg:-ml-8 lg:-mr-8 p-4 pt-8 mt-4 lg:mt-6 bg-green-heinz">
      <div class="pb-8">
        <h2 class="text-center uppercase text-white mb-1 border-none">Vielen Dank für deine Anmeldung!</h2>
        <p class="text-white text-center text-lg font-black">Wir senden dir deine Zugangsdaten per E-Mail und prüfen deine Anmeldung.</p>
        <p class="text-white text-center mt-1">Du kannst in der Zwischenzeit bereits deine Speisekarte, deine Öffnungszeiten und Lieferorte eintragen.</p>
      </div>
    </div>

    <div v-if="host.id" class="-mx-2 pt-8">
      <h1 class="uppercase">Hallo {{ host.item_owner_salutation }} {{ host.item_owner }} !</h1>
    </div>

    <div class="start flex flex-wrap -mx-2 mt-8" v-if="!finished">
      <div class="w-full" :class="{ 'opacity-50': isLoading }">

        <h2 class="uppercase border-none">Deine Daten</h2>

        <form name="review" v-on:submit.prevent="send">

          <div class="w-full max-w-md mb-6">
            <label class="block tracking-wide text-grey-darker text-sm font-bold" for="grid-name">
              Name des Geschäfts:
            </label>
            <div class="relative">
              <input id="grid-name" type="text" required v-model="host.item_name" class="appearance-none block w-full text-grey-darker border border-green py-3 px-4">
            </div>
          </div>

          <div class="w-full max-w-md mb-6">
            <label class="block tracking-wide text-grey-darker text-sm font-bold" for="grid-owner">
              Inhaber:
            </label>
            <div class="relative">
              <input id="grid-owner" type="text" required v-model="host.item_owner" class="appearance-none block w-full text-grey-darker border border-green py-3 px-4">
            </div>
          </div>

          <div class="w-full max-w-md mb-6">
            <label class="block tracking-wide text-grey-darker text-sm font-bold" for="grid-mobile-number">
              Ihre Handynummer:
            </label>
            <div class="relative">
              <input id="grid-mobile-number" type="text" required v-model="host.item_cellphone" class="appearance-none block w-full text-grey-darker border border-green py-3 px-4">
            </div>
          </div>

          <div class="w-full max-w-md mb-6">
            <div class="flex relative">
            <label class="block tracking-wide text-grey-darker text-sm font-bold w-full" for="grid-street">
              Straße:
            </label>
            <label class="block tracking-wide text-grey-darker text-sm font-bold w-32 mr-6" for="grid-number">
              Hausnummer:
            </label>
          </div>
            <div class="flex relative">
              <input id="grid-street" type="text" required v-model="host.item_street" class="appearance-none block w-full text-grey-darker border border-green py-3 px-4">
              <input id="grid-number" type="text" required v-model="host.item_houseno" class="appearance-none block w-32 ml-2 text-grey-darker border border-green py-3 px-4">
            </div>
          </div>

          <div class="w-full max-w-md mb-6">
            <div class="flex relative">
            <label class="block tracking-wide text-grey-darker text-sm font-bold w-32" for="grid-postal-code">
              PLZ:
            </label>
            <label class="block tracking-wide text-grey-darker text-sm font-bold ml-2" for="grid-city">
              Ort:
            </label>
          </div>
            <div class="flex relative">
              <input id="grid-postal-code" type="text" required v-model="host.item_plz" class="appearance-none block w-32 text-grey-darker border border-green py-3 px-4">
              <input id="grid-city" type="text" required v-model="host.item_ort" class="appearance-none block w-full ml-2 text-grey-darker border border-green py-3 px-4">
            </div>
          </div>

          <div class="w-full max-w-md mb-6">
            <label class="block tracking-wide text-grey-darker text-sm font-bold" for="grid-tax-number">
              Steuernummer:
            </label>
            <div class="relative">
              <input id="grid-tax-number" type="text" v-model="host.item_taxnumber" class="appearance-none block w-full text-grey-darker border border-green py-3 px-4">
            </div>
          </div>

          <div class="w-full max-w-md mb-6">
            <label class="block tracking-wide text-grey-darker text-sm font-bold" for="grid-phone-number">
              Telefonnummer:
            </label>
            <div class="relative">
              <input id="grid-phone-number" type="text" required v-model="host.item_phone" class="appearance-none block w-full text-grey-darker border border-green py-3 px-4">
            </div>
          </div>

          <div class="w-full max-w-md mb-6">
            <label class="block tracking-wide text-grey-darker text-sm font-bold" for="grid-email">
              E-Mail Adresse:
            </label>
            <div class="relative">
              <input id="grid-email" type="email" required v-model="host.item_email" class="appearance-none block w-full text-grey-darker border border-green py-3 px-4">
            </div>
          </div>

          <div class="w-full max-w-md mb-6">
            <label class="block tracking-wide text-grey-darker text-sm font-bold" for="grid-register">
              Gewerbeanmeldung
            </label>
            <div class="relative">
              <input id="grid-register" type="file" @change="host.item_file = $event.target.files[0]" class="appearance-none block w-full text-grey-darker border border-green py-3 px-4">
            </div>
          </div>

          <div class="w-full max-w-md mb-6">
            <div class="relative mt-4">
              <label class="flex">
                <input type="checkbox" required v-model="host.item_agb" value="Y" />
                <div class="pl-2">Ich habe die <a href="/agb/anbieter" target="_blank" class="text-black">Allgemeinen Geschäftsbedingungen für Anbieter</a> vollständig gelesen und akzeptiere sie uneingeschränkt. Für Bestellungen, die dir von {{ site.domain }} vermittelt werden, fällt eine Umsatzprovision i.H.v. {{ provision }}% an. Trinkgelder sind provisionsfrei. Für Onlinezahlungen fallen zusätzliche Gebühren des jeweiligen Anbieters an - hier geben wir unsere vergünstigten Konditionen 1:1 an dich weiter.</div>
              </label>
            </div>
          </div>

          <input type="submit" :disabled="isLoading" class="bg-green-heinz hover:bg-green-heinz-light text-black py-4 px-2 mb-8 w-full max-w-md" value="Anmeldung absenden" />
        </form>
      </div>
    </div>

  </div>

</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'

export default {
  name: 'Registration',

  data () {
    return {
      isLoading: false,
      finished: false,
      provision: (window.type === 'strandbutler' ? 13 : 10),
      host: {
        item_name: '',
        item_owner: '',
        item_street: '',
        item_houseno: '',
        item_plz: '',
        item_ort: '',
        item_taxnumber: '',
        item_phone: '',
        item_cellphone: '',
        item_email: '',
        item_system: window.type,
        item_file: null
      }
    }
  },

  props: [
    'mode',
    'hideHeadline'
  ],

  mounted () {
    if (this.$route.name === 'RegistrationByQr') {
      this.loadQrCodeData()
    }
  },

  methods: {
    send (e) {
      e.preventDefault()
      if (this.isLoading) return

      this.isLoading = true

      let formData = new FormData()
      Object.entries(this.host).forEach(([key, value]) => {
        formData.append(key, value)
      })

      axios.post(endpoints.registration, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
        .then(({ data }) => {
          this.finished = true
        })
        .finally(() => {
          this.isLoading = false
        })

      return false
    },

    loadQrCodeData () {
      axios.get(endpoints.qrCodeContact + '/' + this.$route.params.hash + '/' + this.$route.params.id)
        .then(({ data }) => {
          this.host = data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/registration/index.vue